import React from "react";

import { DeleteOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";

import NoResults from "../../../../../Common/NoResultsGIF";
import StyledScrollbar from "../../../../../Common/UIComponents/StyledScrollbar";

import { ReactComponent as LoadingDots } from "../../../../../../assets/images/common/LoadingDots.svg";
import pumpkinIcon from "../../../../../../assets/images/environment/pumpkin.gif";

import { designTokens } from "../../../../../../styles/tokens";

import "./InvitedUsers.css";

export default function InvitedUsers({ invitedUsers, loadingData, handleDeleteModal }) {
  return (
    <div className="InviteModal__SharedListContainer">
      <div className="InviteModal__Title">Invited Users</div>
      <div className="InviteModal__SharedList">
        {invitedUsers.length === 0 && (
        <div className="InviteModal__NoResults">
          {!loadingData
            ? <NoResults image={pumpkinIcon} message="No users found!" className="InviteModal__NoResults__GIF" />
            : <LoadingDots width={30} height={30} fill={designTokens.colorBorderPrimary} />}
        </div>
        )}
        {invitedUsers.length > 0
      && (
      <StyledScrollbar id="InviteModal_Scrollbar">
        <div className="InviteModal_ListContainer">
          {invitedUsers.map((user) => (
            <div key={user.user_email} className="InviteModal__EmailContainer">
              <div className="InviteModal__Email">
                <Avatar
                  size={24}
                  icon={<UserOutlined />}
                  className="InviteModal__PersonAvatar"
                  aria-hidden
                />
                <span>{user.user_email}</span>
              </div>
              <DeleteOutlined
                className="InviteModal__DeleteIcon"
                onClick={() => handleDeleteModal(true, user.user_email)}
                aria-label={`Remove invite for ${user.user_email}`}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleDeleteModal(true, user.user_email);
                  }
                }}
              />
            </div>
          )) }
        </div>
      </StyledScrollbar>
      )}
      </div>
    </div>
  );
}
